"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GiftOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var GiftOutlineSVG = function GiftOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29,8H24.44A3.91,3.91,0,0,0,25,6a4,4,0,0,0-7-2.66,16.85,16.85,0,0,0-2,2.79,16.85,16.85,0,0,0-2-2.79A4,4,0,0,0,7,6a3.91,3.91,0,0,0,.56,2H3A1,1,0,0,0,2,9v8a1,1,0,0,0,1,1H4v9a3,3,0,0,0,3,3H25a3,3,0,0,0,3-3V18h1a1,1,0,0,0,1-1V9A1,1,0,0,0,29,8ZM19.51,4.66A2,2,0,1,1,21,8H17.29A13.16,13.16,0,0,1,19.51,4.66ZM9,6a2,2,0,0,1,3.49-1.34A13.16,13.16,0,0,1,14.71,8H11A2,2,0,0,1,9,6ZM4,10h9v6H4ZM7,28a1,1,0,0,1-1-1V18h7V28Zm8,0V10h2V28Zm11-1a1,1,0,0,1-1,1H19V18h7Zm2-11H19V10h9Z"
  }));
};
exports.GiftOutlineSVG = GiftOutlineSVG;
GiftOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(GiftOutlineSVG);
exports.default = _default;